import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class Overlay extends Component {
  render() {
    const { children, hidden, onClick } = this.props;

    return ReactDOM.createPortal(
      <div className="overlay" hidden={hidden} onClick={onClick}>
        {children}
      </div>,
      document.getElementById('modal-root')
    );
  }
}

export default Overlay;
